import { render, staticRenderFns } from "./MusicCategories.vue?vue&type=template&id=59f39222&scoped=true"
import script from "./MusicCategories.vue?vue&type=script&lang=js"
export * from "./MusicCategories.vue?vue&type=script&lang=js"
import style0 from "./MusicCategories.vue?vue&type=style&index=0&id=59f39222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f39222",
  null
  
)

export default component.exports